/**
 * Thrown when artwork dimensions are still loading (zero width/height).
 * This is an expected transient UI condition, not a true cart failure.
 */
export class DimensionLoadingError extends Error {
  constructor() {
    super("Artwork dimensions are still loading. Please wait a moment and try again.");
    this.name = "DimensionLoadingError";
  }
}

export { OutOfStockError } from "./OutOfStockError";
export type { OutOfStockEntry } from "./OutOfStockError";
